 
import { apiWithoutAuth } from "./api";

const AuthApiCall = async ({ url, method = "POST", data = null, params = null }) => {
  try {
    const response = await apiWithoutAuth({
      url,
      method,
      data,
      params,
    });

    return response;
  } catch (error) {
 

    throw error;
  }
};

export default AuthApiCall;
